import {
    FaBell,
    FaBrain,
    FaChartLine,
    FaFileInvoice,
    FaFlask,
    FaHandHoldingHeart,
    FaHeartPulse,
    FaShieldHeart
} from "react-icons/fa6";

export const serviceCards = [
    {
        label: "Brain health",
        icon: FaBrain,
        title: "Empower Minds Together",
        description:
            "Neurofeedback therapy with a clean patient experience and a provider-friendly model built for modern practices.",
        link: "/services/neurofeedback",
    },
    {
        label: "Patient care",
        icon: FaHeartPulse,
        title: "Allergy Testing & Immunotherapy",
        description:
            "A practical program that helps clinics deliver support while keeping the workflow simple and efficient.",
        link: "/services/allergy-testing",
    },
    {
        label: "Revenue cycle",
        icon: FaFileInvoice,
        title: "Medical Billing Services",
        description:
            "Billing support that helps you stay organized, compliant, and focused on patient care instead of admin load.",
        link: "/services/medical-billing-services",
    },
    {
        label: "Clinical precision",
        icon: FaChartLine,
        title: "Mini C-Arm Injections",
        description:
            "Precision-centered support for knee injection workflows with a polished clinical presentation.",
        link: "/services/osteoarthritis-injections",
    },
    {
        label: "Support pathway",
        icon: FaHandHoldingHeart,
        title: "Wound Care Solutions",
        description:
            "An ethical wound-care option that brings practical value to patients and providers alike.",
        link: "/services/advance-wound-care",
    },
    {
        label: "Diagnostics",
        icon: FaShieldHeart,
        title: "Neuropathy & Vascular Dysfunction",
        description:
            "Early detection support designed to help clinicians identify issues quickly and confidently.",
        link: "/services/tm-flow-testing-dysfunction",
    },
    {
        label: "Lab workflow",
        icon: FaFlask,
        title: "In-house Lab Services",
        description:
            "A streamlined lab workflow that supports operational growth while keeping the experience polished.",
        link: "/services/in-house-lab-services",
    },
    {
        label: "Testing support",
        icon: FaBell,
        title: "Toxicology Lab Solutions",
        description:
            "Reliable testing support that keeps care moving and gives your team a clean, modern process.",
        link: "/services/toxicology-laboratory-solutions",
    },
];